import { getConfig } from '@/utils/config/config';
import { buildApiUrl } from '@/utils/url/build-url';
import { fetchApi } from './fetcher';
import { COOKIES, getCookieValue } from '@/utils/cookies';
import type { Brand } from '@/types/constants';

const getHeaders = async () => {
    const region = await getCookieValue(COOKIES.REGION);
    const brand = process.env.BRAND as Brand;

    return {
        'x-region-code': region,
        'x-brand': brand,
        'Content-Type': 'application/json'
    };
};

export type DailyJackpotPot = {
    id: number;
    key: string;
    name: 'Daily Jackpot' | 'Mini Jackpot';
    type: 'time';
    state: string; // 'active'
    amount: number;
    prevAmount: number;
    prevWinAmount: number;
    seedAmount: string;
    seedNextAmount: string;
    prevWinTime: string;
    currency: 'USD';
    currencySymbol: '$';
    time: {
        current: string;
        periods?: string;
        target?: string;
        started: string;
        won: string;
        hidden: string;
    };
    jackpotState: string; // 'ticking'
};

type DailyJackpotsResponseProps = {
    provider: 'RedTiger';
    region: string;
    brand: 'fanduel' | 'mohegansun';
    pots: DailyJackpotPot[];
};

type DailyJackpotsProps = {
    state?: string;
    cycle?: number;
    callback?: () => void;
};

export const getDailyJackpots = async ({
    state,
    cycle,
    callback
}: DailyJackpotsProps): Promise<DailyJackpotPot[] | []> => {
    const { apis } = getConfig();
    const dailyJackpotsUrl = buildApiUrl(apis.JackpotsClient);
    const headers = await getHeaders();

    try {
        const cycleParam = state === 'cycle' ? (typeof cycle === 'number' ? `&cycle=${cycle}` : '') : '';
        const stateParam = state ? `/?state=${state}` : '';
        const url = `${dailyJackpotsUrl}${stateParam}${cycleParam}`;

        const networkConfig = getConfig().network?.InternalJackpotsClient;
        const res = await fetchApi(url, { method: 'GET', headers }, networkConfig ? { networkConfig } : undefined);

        const data: DailyJackpotsResponseProps[] = await res.json();
        callback && callback();
        return data?.[0]?.pots;
    } catch (error) {
        console.log(`Could not get daily jackpots: ${(error as Error).message}`);
        return [];
    }
};
